import { useAtomValue } from "jotai";
import { useInitGlobalDDLoggerContext } from "../datadog/useInitGlobalDDLoggerContext";
import { visitorStateAtom } from "./state";
import { useVisitorId } from "./useVisitorId";
import { useParams } from "react-router-dom";
import {
  admissionAttemptsAtom,
  joinAttemptsAtom,
} from "./waiting-room/admission/state";

export function useInitVisitorGlobalDDLoggerContext() {
  const visitorId = useVisitorId();
  const visitorState = useAtomValue(visitorStateAtom);
  const admissionAttempts = useAtomValue(admissionAttemptsAtom);
  const joinAttempts = useAtomValue(joinAttemptsAtom);
  const { providerShortId } = useParams<{ providerShortId: string }>();

  useInitGlobalDDLoggerContext({
    admissionAttempts,
    providerShortId,
    visitorId,
    visitorState,
    joinAttempts,
  });
}
